if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
} 

(function(){
    $(".fancybox2").fancybox({
		fitToView : false,
		autoSize : false,
		width: '60%'
	});
    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    let weeDay = [ 
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
    ];

    let form_id_493 = document.querySelector( "#form_id-493" )
    if( form_id_493 ){

        let start_date = document.querySelector( "[name=start_date]" )
        start_date.addEventListener( "change", ( e ) => {
            start_date.value += " " + weeDay[ new Date( e.target.value ).getDay() ]
        } )

        let end_date = document.querySelector( "[name=end_date]" )
        end_date.addEventListener( "change", ( e ) => {
            end_date.value += " " + weeDay[ new Date( e.target.value ).getDay() ]
        } )

        let response_due_date = document.querySelector( "[name=response_due_date]" )
        response_due_date.addEventListener( "change", ( e ) => {
            response_due_date.value += " " + weeDay[ new Date( e.target.value ).getDay() ]
        } )

        let decision_due_date = document.querySelector( "[name=decision_due_date]" )
        decision_due_date.addEventListener( "change", ( e ) => {
            decision_due_date.value += " " + weeDay[ new Date( e.target.value ).getDay() ]
        } )

    }

    let form_id_487 = document.querySelector( "#form_id-487" )
    if( form_id_487 ){

        let start_date = document.querySelector( "[name=start_date]" )
        start_date.addEventListener( "change", ( e ) => {
            start_date.value += " " + weeDay[ new Date( e.target.value ).getDay() ]
        } )

        let end_date = document.querySelector( "[name=end_date]" )
        end_date.addEventListener( "change", ( e ) => {
            end_date.value += " " + weeDay[ new Date( e.target.value ).getDay() ]
        } )

        let response_due_date = document.querySelector( "[name=response_due_date]" )
        response_due_date.addEventListener( "change", ( e ) => {
            response_due_date.value += " " + weeDay[ new Date( e.target.value ).getDay() ]
        } )

        let decision_due_date = document.querySelector( "[name=decision_due_date]" )
        decision_due_date.addEventListener( "change", ( e ) => {
            decision_due_date.value += " " + weeDay[ new Date( e.target.value ).getDay() ]
        } )

    }

    //QR Menu shortcode to remove everything 
	if(document.getElementsByClassName('qr-resorces').length > 0){

		let headerN = document.getElementsByTagName('header')[0]; 
		let footerN = document.getElementsByTagName('footer')[0];
		let topContent = document.getElementsByClassName('top-content')[0];
		let jsMenuBtn = document.getElementsByClassName('jsMenuBtn')[0];
		let jsLanguage = document.getElementsByClassName('js-language-box')[0];
		let jsBooking = document.getElementsByClassName('js-booking-trigger')[0];
		let privarynavigation = document.getElementsByClassName('privary-navigation')[0];

		if( headerN || footerN || topContent || jsMenuBtn || jsLanguage || jsBooking || privarynavigation ) {
			headerN.classList.add('qr'); 
			footerN.classList.add('hidden');
			topContent.classList.add('hidden');
			jsMenuBtn.classList.add('hidden');
			jsLanguage.classList.add('hidden');
			jsBooking.classList.add('hidden');
			privarynavigation.classList.add('hidden');
		}
	}

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick();

    // Get tags
    function roomsTabs() {
        let tabs = document.querySelectorAll('.js-tags-tab'),
            rooms = document.querySelectorAll('.js-tab-pane');
        tabs.forEach(tab =>{
            tab.addEventListener('click',() => {
                document.querySelector('.is-active').classList.remove('is-active');
                tab.classList.add('is-active');
                let tabAttr = tab.getAttribute('data-tag');
                rooms.forEach(room =>{
                    let roomAttr = room.getAttribute('data-tag').split(' ');
                    console.log(roomAttr[1]);
                    if(tabAttr === roomAttr[0] || tabAttr === roomAttr[1]){
                        room.classList.add('js-active');
                    }else{
                        room.classList.remove('js-active');
                    }
                })
            });
        });
    }
    roomsTabs();
    
    $(".form-module input[type='text']").on('change',function(e){
        // const idForm = $("input[name='form_id']").val();
        // if(e.target.name==='organization' && e.target.value.length>0 && $("input[name='event_name']").val().length>0){
        //     $(`#subject_${idForm}`).val('RFP '+e.target.value+' '+$("input[name='event_name']").val());
        // }

        // if(e.target.name==='event_name' && e.target.value.length>0 && $("input[name='organization']").val().length>0){
        //     $(`#subject_${idForm}`).val('RFP '+$("input[name='organization']").val()+' '+e.target.value);
        // }
        // console.log($(`#subject_${idForm}`).val());
    })

})();

let buttonLightbox = document.querySelector('#lightbox-button a');
function openFancybox() {
    buttonLightbox.click();
}